import Dexie from 'dexie';

import { exportDB,importDB } from 'dexie-export-import'


    //Creation de la db
    let db=new Dexie("ScenarFab");



    db.debug=false;

    //creation des tables
    db.version(1).stores({
        taches: 'id,level,parent,[level+parent],[parent+type],type,data.label,*requis',
        element:'++id,type,name,&slug,*carac,*lieu',
        resultat: 'id,type,from,*data.condition,*data.consequence,*data.meta',
        carac: '++id,&[type+lieu+clef],[lieu+clef],type,lieu,clef,*kw',
        liens: '++id,type,from,fromExact,to,[fromExact+to],[from+to]'
    });

    db.on("populate", function() {
        db.element.add({type: "JOUEUR", color: "#000000",icone:"user",nom:"Joueur",slug:"JOUEUR",carac:[],lieu:[]});
    });

    db['do']= {

        async download(){
            try{
                const res= await exportDB(db,{prettyJson:true})
                return res
            } catch (error) {
                console.error(''+error);
                return false
            }
        },

        async upload(file){
            try{
            await db.delete();
            db = await importDB(file)
            } catch (error) {
                console.error(''+error);}
        },

        //*****************************************
        // TASK FUNCTION
        //*****************************************

        async getTask(taskID){
            return await db.taches.get(taskID)
        },

        async loadTask(){
            let res=await db.taches.toArray()
            return res
        },

        async loadTaskOf(mylevel,myparent){
            let res=await db.taches.where({level:mylevel,parent:myparent}).toArray()
            return res
        },


        async countChildrenOf(mylevel,mytaskid){
            let res=await db.taches.where({level:mylevel,parent:mytaskid}).count()
            return res
        },
        async countChildrenOfTask(mytaskid){
            let res=await db.taches.where({parent:mytaskid, type:'TASK'}).count()
            return res
        },

        async getChildrenOfTask(mytaskid){
            let res=await db.taches.where({parent:mytaskid}).toArray()
            return res
        },

        async getParent(mytaskid){
            const  res=await db.taches.get(mytaskid)
            return {level:res.level,parent:res.parent}
        },

        async saveTask(mytask){
            await db.taches.put(mytask);
            return true
        },

        async deleteTask(taskId){

            await db.taches.delete(taskId);

            await db.liens
                .where('from').equals(taskId)
                .or('to').equals(taskId)
                .delete()

            await db.carac
                .where('lieu').equals(taskId)
                .delete()

            const resList=await db.do.getResultatOutOf(taskId)

            if(resList){
                for(const res of resList){
                    await db.do.deleteResultat(res)
                }
            }

            return true
        },

        async updateTaskPos(taskId,pos){
            await db.taches.update(taskId,{position:pos});
            return true
        },

        async updateTask(task){
            await db.taches.update(task.id,task);
            return true
        },

        async searchDialogues(myLocuteur){
            let res=await db.taches.where("data.label").equals(myLocuteur).toArray()
            return res
        },

        //*****************************************
        // RESULTATS FUNCTION
        //*****************************************

        //ecrase et pis voilà
        async saveElement(myelement){
            try{
                await db.element.put(myelement)
                return true
            } catch(err) {
                return false
            }
        },

        async getElement(elementSlug){
            return await db.element.where('slug').equals(elementSlug).toArray()
        },


        async getElementListAll(){
            return await db.element.toArray()
        },


        async getElementListType(mytype){
            return await db.element.where('type').equals(mytype).toArray()
        },

        //*****************************************
        // RESULTATS FUNCTION
        //*****************************************

        //ecrase et pis voilà
        async getResultat(resultID){
            return  await db.resultat.get(resultID)
        },

        //ecrase et pis voilà
        async saveResultat(myresult){
            await db.resultat.put(myresult)
            return true
        },

        async updateResultat(myresult){
            await db.resultat.put(myresult)

            // On met à jour la couleur des liens qui sortent de la
            await db.liens.where('fromExact').equals(myresult.id)
                .modify({"data.color":myresult.data.color,"data.label":myresult.data.label})

            return true
        },

        async getResultatOutOf(taskID){
            return await db.resultat.where('from').equals(taskID).toArray()
        },

        async countResultatOutOf(taskID){
            return await db.resultat.where('from').equals(taskID).count()
        },

        async deleteResultatOutOf(taskID){
            return await db.resultat.where('from').equals(taskID).delete()
        },

        async setResultatOutOfToDIAL(taskID){
             await db.resultat.where('from').equals(taskID).modify({"type":"DIAL"})
            return true
        },

        async deleteResultat(myresult){
            await db.resultat
                .where('id').equals(myresult.id)
                .delete();

            await db.carac
                .where('lieu').equals(myresult.id)
                .delete();

            await db.liens
                .where('fromExact').equals(myresult.id)
                .delete()

            return true
        },

        async replaceCaracName(resultID,oldCarac,newCarac){
             let myresult= await db.resultat.get(resultID)


            const foundCond =  myresult.data.condition.findIndex(x => x  === oldCarac)
            myresult.data.condition[foundCond] = newCarac

            const foundCons =  myresult.data.consequence.findIndex(x => x  === oldCarac)
            myresult.data.consequence[foundCons] = newCarac;

            const foundMeta =  myresult.data.meta.findIndex(x => x  === oldCarac)
            myresult.data.meta[foundMeta] = newCarac


            //on update bourrin grace à "put"
            await db.resultat.put(myresult)
        },

        //*****************************************
        // CARACFUNCTION
        //*****************************************
        async saveCarac(value){
            try{
                 await db.carac.put(value)
                return true
            } catch(err) {
                return false
            }

        },


        // FONCTION COMPLEXE
        // Il faut propager correctement

        async deleteCarac(caracId){

            //Attention à la propagation
            let myCarac=await db.carac.get(caracId)

            if(myCarac.type==='COND' || myCarac.type==='CONS' || myCarac.type==='META'){
                //C'est une carac de résultats donc il faut en enlever la reference
                // charge le resultat concerné
                let myresult= await db.resultat.get(myCarac.lieu)

                //on filtre
                myresult.data.condition=myresult.data.condition.filter(thing => thing!=myCarac.clef)
                myresult.data.consequence=myresult.data.consequence.filter(thing => thing!=myCarac.clef)
                myresult.data.meta=myresult.data.meta.filter(thing => thing!=myCarac.clef)

                //on update bourrin grace à "put"
                await db.resultat.put(myresult)
            }
            else{
                //c'est une carac d'élément mais c'est géré au moment du delete dans vuejs
            }

            //c'est bon on peut dégager la carac
            await db.carac.delete(caracId)
            return true
        },

        async deleteCaracClef(caracClef){
            await db.carac.where('clef').equals(caracClef).delete()
            return true
        },

        async getCaracClef(caracClef){
            return db.carac.where('clef').equals(caracClef).toArray()
        },

        async getCaracLieu(caracLieu){
            return db.carac.where('lieu').equals(caracLieu).toArray()
        },

        async getCarac(type,lieu,clef){
           try{
               return await db.carac.where('[type+lieu+clef]').equals([type,lieu,clef]).toArray()
           } catch(err) {
            return false
            }
        },

        async getCaracAllType(lieu,clef){
            return await db.carac.where('[lieu+clef]').equals([lieu,clef]).toArray()

        },

        async searchBegin(kw){
          const fromSlug=await db.carac.where('clef').startsWithIgnoreCase(kw).distinct().toArray()
          const fromKW= await db.carac.where('kw').startsWithIgnoreCase(kw).distinct().toArray()

          return fromSlug.concat(fromKW)
        },

        //*****************************************
        // LINK FUNCTION
        //*****************************************
        async getAllLink(){
            return await db.liens.toArray()

        },

        async getLinkOutOf(taskRef){
            return await db.liens.where('from').equals(taskRef)
                .toArray() // .or('to').equals(taskRef)

        },

        async getLinkGoingTo(taskRef){
            return await db.liens.where('to').equals(taskRef)
                .toArray() // .or('to').equals(taskRef)

        },

        async countLinkToAndFrom(taskRef,taskDest){
            const to= await db.liens.where({from : taskRef, to: taskDest}).count()
            const from= await db.liens.where({from : taskDest, to: taskRef}).count()
            return [to,from]
        },

        async linkExist(fromExact,to){
            let nb=0
            const tmp=await db.liens.where({fromExact:fromExact, to: to}).toArray()
            nb=await tmp.length
            return nb
        },

        async createLink(value){
            await db.liens.put(value)
            return true
        },

        async updateLink(value){
            await db.liens.put(value)
            return true
        },

        async deleteLink(linkId){
            await db.liens.delete(linkId)
            return true
        },

        //*****************************************
        // LINK FUNCTION
        //*****************************************

        async clearAll(){
            await db.delete()
            return true
        }

    }


    export default db;
